import { Ban, CircleSlash } from "lucide-react";
import { Alert, AlertDescription, AlertTitle } from "@/components/ui/alert";
import { PhysicalClientStatus } from "@/lib/api";
import { formatDateTime } from "@/lib/formatters";
import { usePhysicalClientHistory } from "./usePhysicalClientHistory";

interface PhysicalClientStatusNoticeProps {
  physicalClientId: number;
  status: PhysicalClientStatus;
}

const TITLES: Record<Exclude<PhysicalClientStatus, "Active">, string> = {
  Inactive: "Cliente inativo",
  Blocked: "Cliente bloqueado",
};

/**
 * Aviso no topo do detalhe quando o cliente não está ativo, com quem mudou a situação, quando e o motivo (da última
 * mudança de situação no histórico). Para cliente ativo não renderiza nada nem busca o histórico.
 */
export function PhysicalClientStatusNotice({ physicalClientId, status }: PhysicalClientStatusNoticeProps) {
  const inactive = status !== "Active";
  const history = usePhysicalClientHistory(physicalClientId, { enabled: inactive });

  if (!inactive) return null;

  const lastChange = history.data?.find((entry) => entry.action === "StatusChange" && entry.current?.status === status);
  const Icon = status === "Blocked" ? Ban : CircleSlash;

  return (
    <Alert variant={status === "Blocked" ? "destructive" : "default"}>
      <Icon className="h-4 w-4" aria-hidden="true" />
      <AlertTitle>{TITLES[status]}</AlertTitle>
      <AlertDescription>
        {lastChange ? (
          <>
            Desde {formatDateTime(new Date(lastChange.performedAt))}, por {lastChange.performedBy}.
            {lastChange.comment && <> Motivo: {lastChange.comment}</>}
          </>
        ) : (
          "Use os botões de situação para reativar o cadastro."
        )}
      </AlertDescription>
    </Alert>
  );
}
